$(window).on('load', function() {
  equalheight();
});

$(window).on('resize', function() {
  equalheight();
});

function equalheight(){
  var identifiers = [];
  $('[data-equal-height]').each(function(key, element){
    var identifier = $(element).attr('data-equal-height');
    if(jQuery.inArray(identifier, identifiers) == -1) identifiers.push(identifier);
  });

  // run over all identifiers and set an equal height for all elements of an identifier

  $.each(identifiers, function(key, identifier){
    var maxheight = 0;
    $('[data-equal-height="'+identifier+'"]').each(function(key, element){
      $(element).height('auto');
      if($(element).height() > maxheight) maxheight = $(element).height();
    });

    if($(window).width() > 767){
      $('[data-equal-height="'+identifier+'"]').height(maxheight);
    }
  });
}



// WEBPACK FOOTER //
// ./js/modules/_equalheight.js